import * as reducers from '../reducers-slice'

export const checkProjectAcquisitionErrors = (dispatch: any, error: any) => {
  if (error.response && error.response?.data?.detail) {
    dispatch(reducers.setPurchaseOperationError(error.response.data.detail))
  } else {
    dispatch(reducers.setPurchaseOperationError(error.message))
  }
}

export const checkBrokerageErrors = (dispatch: any, error: any) => {
  if (error.response && error.response?.data?.detail) {
    dispatch(reducers.setBrokerageOperationError(error.response.data.detail))
  } else {
    dispatch(reducers.setBrokerageOperationError(error.message))
  }
}

export const checkTransferProjectErrors = (dispatch: any, error: any) => {
  if (error.response && error.response?.data?.data) {
    dispatch(reducers.setTransferProjectError(error.response.data.data))
  }
}
